import Cookies from 'js-cookie';

(function (window, document) {
    const savedTheme = localStorage.getItem('theme');
    const leftIcon = document.getElementsByClassName("contrast-left");
    const rightIcon = document.getElementsByClassName("contrast-right");
    const logo = document.getElementById("visio_logo");
    const logoInverted = document.getElementById("visio_logo_inverted");

    if (savedTheme) {
        document.body.classList.add(savedTheme);
        leftIcon[0].classList.add("active")
        rightIcon[0].classList.add("active")
        logo.classList.add("hidden");
        logoInverted.classList.remove("hidden");
    }

    const themeToggle = document.querySelectorAll('#theme-toggle');
    themeToggle.forEach(span => {
        span.addEventListener('click', () => {
            const body = document.body
            body.classList.toggle('contrast');
            const newTheme = document.body.classList.contains('contrast') ? 'contrast' : '';
            localStorage.setItem('theme', newTheme);

            if (document.body.classList.contains('contrast')) {
                leftIcon[0].classList.add("active")
                rightIcon[0].classList.add("active")
                logo.classList.add("hidden");
                logoInverted.classList.remove("hidden");
            } else {
                leftIcon[0].classList.remove("active")
                rightIcon[0].classList.remove("active")
                logo.classList.remove("hidden");
                logoInverted.classList.add("hidden");
            };
        });
    })

    const fontSizes = ['small', 'medium', 'large'];
    const fontSpanElements = document.querySelectorAll('.font-size');
    const savedFontSize = localStorage.getItem('fontSize');

    if (fontSizes.includes(savedFontSize)) {
        document.body.classList.add(`${savedFontSize}`);
    } else {
        document.body.classList.add('small');
    }

    fontSpanElements.forEach(span => {
        span.addEventListener('click', () => {
            const selectedSize = span.dataset.size;

            fontSizes.forEach(size => {
                if (size === selectedSize) {
                    document.body.classList.add(`${size}`);
                    localStorage.setItem('fontSize', size);
                } else {
                    document.body.classList.remove(`${size}`);
                }
            });
        });
    });

    const menuButton = document.getElementById("open-menu");
    const overlay = document.getElementById("overlay");
    const mobileSearchButton = document.getElementById("search-btn");
    const mobileSearchContainer = document.getElementById("mobilesearch");
    const mainContent = document.getElementById("maincontent");
    const headerHeight = document.getElementById("headercontainer").offsetHeight;

    const toggleMenuIcon = (element) => {
        element.classList.toggle("fa-bars");
        element.classList.toggle("fa-times");
        if (!$('body').hasClass('menu-open')) {
            $("#menu-btn span").html("Menu openen");
            $('#mobilemenu').attr('aria-hidden', 'true');
            $("#mobilemenu a").prop('tabIndex', -1);
        } else {
            $("#menu-btn span").html("Menu sluiten");
            $('#mobilemenu').attr('aria-hidden', 'false');
           
            $("#mobilemenu").find('a:first').focus();
            var items = 8;
            $( "#mobilemenu a" ).each(function() {
                $(this).prop('tabIndex', items);
                items++;
            });
        }
    };

    menuButton.addEventListener("click", () => {
        document.body.classList.toggle("menu-open");
        overlay.classList.toggle("hidden");
        let hasOverlay = overlay.classList.contains("hidden");
        if (!hasOverlay) {
            document.body.classList.add("fixed");
        } else {
            document.body.classList.remove("fixed");
        };
        toggleMenuIcon(menuButton);
    });

    overlay.addEventListener("click", () => {
        document.body.classList.toggle("menu-open");
        overlay.classList.toggle("hidden");
    });

    mobileSearchButton.addEventListener("click", () => {
        mobileSearchContainer.classList.toggle("hide-search");
        document.body.classList.toggle("search-closed");
        if($('body').hasClass('search-closed')) {
            $('#search-btn i.fa').removeClass('fa-search-minus').addClass('fa-search');
            $("#search-btn span").html("Zoekvenster openen");
        } else {
            $('#search-btn i.fa').removeClass('fa-search').addClass('fa-search-minus');
            $("#search-btn span").html("Zoekvenster sluiten");
        }
    });


    window.addEventListener("resize", () => {
        let main = document.getElementById("maincontent")
        let cookies = Cookies.get('AVGKennisportaalPermissions') ? true : false;
        let cookieBar = document.querySelector('#cookies');
        let topBarContainer = document.getElementById("topbarcontainer");
        if (!cookies && !cookieBar) {
            (cookieBar?.offsetHeight + "px") !== topBarContainer.style.marginTop && (topBarContainer.style.marginTop = cookieBar?.offsetHeight + "px");
        }
        else
        {
            topBarContainer.style.marginTop = 0;
        }

        if (window.innerWidth > 768) {
            main.style.paddingTop = '0px'
            document.body.classList.remove("menu-open");
            document.body.classList.remove("fixed");
            let hasOverlay = overlay.classList.contains("hidden");
            if (!hasOverlay) {
                overlay.classList.add("hidden");
            }
        } else {
            main.style.paddingTop = '124px'
        }

    });

    function setup_navigation(options) {
        var settings = $.extend({
            menuHoverClass: "show-menu"
        }, options);

        // Target the specific ul with id "domeinmenu"
        var menuItems = $("#domeinmenu").find("> li > a");

        menuItems.next("ul").attr({
            "aria-hidden": "false",
            role: "menu"
        }).find("a").attr("tabIndex", -1);

        menuItems.each(function () {
            if ($(this).next("ul").length > 0) {
                $(this).parent("li").attr("aria-haspopup", "true");
            }
        });

        menuItems.hover(function () {
            handleMenuItemInteraction($(this), settings);
        });

        menuItems.focus(function () {
            handleMenuItemInteraction($(this), settings);
        });

        menuItems.keydown(function (e) {
            handleKeyDownEvent($(this), e, settings);
        });

        var submenuItems = menuItems.parent("li").find("ul").find("a");

        submenuItems.keydown(function (e) {
            handleSubmenuKeyDownEvent($(this), e, settings);
        });

        menuItems.find("a").last().keydown(function (e) {
            if (e.keyCode === 9) {
                $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
            }
        });

        menuItems.mouseleave(function () {
            $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
        });

        $(document).click(function () {
            $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
        });

        $(this).click(function (e) {
            e.stopPropagation();
        });

        function handleMenuItemInteraction(item, settings) {
            item.closest("ul").attr("aria-hidden", "false").find("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
            item.next("ul").attr("aria-hidden", "false").addClass(settings.menuHoverClass).find("a").attr("tabIndex", 0);
        }

        function handleKeyDownEvent(item, event, settings) {
            var keyCode = event.keyCode;
            // switch (keyCode) {
            //     case 37:
            //         handleArrowKey(item, "left");
            //         break;
            //     case 38:
            //         handleArrowKey(item, "up", settings);
            //         break;
            //     case 39:
            //         handleArrowKey(item, "right");
            //         break;
            //     case 40:
            //         handleArrowKey(item, "down", settings);
            //         break;
            //     case 13:
            //     case 32:
            //         handleEnterSpaceKey(item);
            //         break;
            //     case 27:
            //         handleEscapeKey(settings);
            //         break;
            //     default:
            //         handleAlphabetKey(item, keyCode);
            // }
        }

        function handleSubmenuKeyDownEvent(item, event, settings) {
            var keyCode = event.keyCode;
            // Handle submenu keydown events
            // Add your logic here
        }

        function handleEscapeKey(settings) {
            $("." + settings.menuHoverClass).attr("aria-hidden", "false").removeClass(settings.menuHoverClass).find("a").attr("tabIndex", -1);
        }

    };

    setup_navigation();

    function searchTextBoxFocus() {
        var container = $('.predictiveSearchHolder').find('.predictivesearchcontainer');
        var searchTextBox = $('.VisioSearchTextBox');

        function showContainer() {
            if (container && container.html().length > 0) {
                container.show();
            }
        }
        function hideContainer() {
            container.hide();
        }
        searchTextBox.on('focus', showContainer);
        
    }
    searchTextBoxFocus();

    window.addEventListener('mouseup',function(event){
        const pol =  $('.predictiveSearchHolder').find('.predictivesearchcontainer');
        const searchBox = $('.searchBox');
        if(event.target != searchBox && event.target.parentNode != searchBox){
            pol.hide();
        }
     });  
    
   

    $(document).on('keydown', function (e) {
        
        if (e.keyCode === 27) {
            // ESC
            if ($('body').hasClass('menu-open')) {
                $('#open-menu').trigger('click');
            }
            var container =
                $(window).width() < 768
                    ? $('.predictivesearchcontainer--mobile')
                    : $('.predictivesearchcontainer--desktop');
            if (container) {
                container.hide();
            }
        }

        if (
            e.keyCode === 9 ||
            e.keyCode === 8 ||
            e.keyCode === 38 ||
            e.keyCode === 40
        ) {
            
            var $focused = $(':focus');
            var className = $focused.attr('class');
            if (e.keyCode === 40) {
                
                var container =
                $(window).width() < 768
                    ? $('.predictivesearchcontainer--mobile')
                    : $('.predictivesearchcontainer--desktop');

                if (
                    !!className &&
                    $('.js-search-term:focus').length > 0 &&
                    container &&
                    container.html().length > 0
                    
                ) {
                    container.find('a:first').focus();
                }
				
            }

            if (e.keyCode === 40 || e.keyCode === 38) {
                
                if (!!className && className.indexOf('predictivesearch--itemlink') > -1) {
                    let index = parseInt(
                        className.substring(className.lastIndexOf('-') + 1)
                    );
                    if (e.keyCode === 40) {
                        
                        if (index === 9) {
                            $('.VisioSearchTextBox').focus();
                           
                        } else {
                            let indexAdd = index === 0 ? 1 : index + 1;
                            var find = $(`.itemlink--${indexAdd}`)[0];
                            if (!find) {
                                $('.VisioSearchTextBox').focus();
                            } else {
                                $('.itemlink--' + indexAdd).focus();
                            }
                        }
                    } else {
                        if (index === 0) {
                            $('.VisioSearchTextBox').focus();
                        } else {
                            let indexMin = index === 1 ? 0 : index - 1;
                            $('.itemlink--' + indexMin).focus();
                        }
                    }
                }

                if (
                    e.keyCode === 38 &&
                    !!className &&
                    className === 'VisioSearchTextBox form-control'
                ) {
                    var lastitem = null;
                    if ($(window).width() < 768) {
                        lastitem = $(
                            '.predictivesearchcontainer--mobile ul li:last-child'
                        ).html();
                    } else {
                        lastitem = $(
                            '.predictivesearchcontainer--desktop ul li:last-child'
                        ).html();
                    }
                    if (!!lastitem) {
                        var lastItemClass = lastitem.substring(
                            lastitem.indexOf('itemlink--'),
                            lastitem.indexOf('itemlink--') + 11
                        );
                        $(`.${lastItemClass}`).focus();
                    }
                }

                e.view.event.preventDefault();
            }
            if (e.keyCode !== 40 && e.keyCode !== 38) {
                if (
                    $focused &&
                    !!className &&
                    (className === 'VisioSearchTextBox form-control' ||
                        className.indexOf('VisioSearchButton') > -1 ||
                        className.indexOf('predictiveSearchHolder') > -1 ||
                        className.indexOf('predictivesearch--itemlink') > -1)
                ) {
                    var container =
                        $(window).width() < 768
                            ? $('.predictivesearchcontainer--mobile')
                            : $('.predictivesearchcontainer--desktop');
                    if (container && container.html().length > 0) {
                        container.show();
                    } else if (
                        !container ||
                        (!!container && container.html().length === 0)
                    ) {
                        container.hide();
                    }
                }
            }
        }
    });

    $(document).on('keyup', function (e) {
        var $focused = $(':focus');
        var className = $focused.attr('class');
        if (
            !!className &&
            !(
                className === 'VisioSearchTextBox form-control' ||
                className.indexOf('VisioSearchButton') > -1 ||
                className.indexOf('predictiveSearchHolder') > -1 ||
                className.indexOf('predictivesearch--itemlink') > -1
            )
        ) {
            var container = $('.predictiveSearchHolder').find(
                '.predictivesearchcontainer'
            );
            if (container) {
                container.hide();
            }
        }
    });

    window.onload = function() {
        // Get the element by ID
        var headerTitle = document.getElementById('headertitle');
        var searchTitle = document.getElementsByClassName('searchtitle')[0];
        let cookies = Cookies.get('AVGKennisportaalPermissions') ? true : false;
        let cookieBar = document.querySelector('#cookies');
        if (cookies && cookieBar)
        {
            cookieBar.remove();
        }
        // Set focus on the element
        if (headerTitle) {
          headerTitle.focus();
        }
        if (searchTitle) {
            searchTitle.focus();
        }
    };

})(window, document);
